import * as React from "react";
type Props = {
  size?: number;
};
function CompletedSvg(props: Props) {
  const { size = 17 } = props;
  return (
    <div
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: "50%",
        backgroundColor: "#20BF7D",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size - 10}
        height={size - 10}
        viewBox="0 0 9 9"
        fill="none"
      >
        <g clipPath="url(#clip0_5867_111291)">
          <path
            d="M3.3 5.2998L1.7 3.6998L0.5 4.8998L3.3 7.6998L8.5 2.4998L7.3 1.2998L3.3 5.2998Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_5867_111291">
            <rect
              width="8"
              height="8"
              fill="white"
              transform="translate(0.5 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

export default CompletedSvg;
